import { render, staticRenderFns } from "./BindDialog.vue?vue&type=template&id=8558da28&scoped=true"
import script from "./BindDialog.vue?vue&type=script&lang=js"
export * from "./BindDialog.vue?vue&type=script&lang=js"
import style0 from "./BindDialog.vue?vue&type=style&index=0&id=8558da28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8558da28",
  null
  
)

export default component.exports